"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Ads API
 * The Spotify Ads API.
 *
 * The version of the OpenAPI document: 3.0.0
 * Contact: selfserve-infra-api@spotify.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ImageToJSON = exports.ImageFromJSONTyped = exports.ImageFromJSON = exports.instanceOfImage = void 0;
var runtime_1 = require("../runtime");
var AspectRatio_1 = require("./AspectRatio");
var Asset_1 = require("./Asset");
var ImageFileType_1 = require("./ImageFileType");
/**
 * Check if a given object implements the Image interface.
 */
function instanceOfImage(value) {
    var isInstance = true;
    return isInstance;
}
exports.instanceOfImage = instanceOfImage;
function ImageFromJSON(json) {
    return ImageFromJSONTyped(json, false);
}
exports.ImageFromJSON = ImageFromJSON;
function ImageFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return __assign(__assign({}, (0, Asset_1.AssetFromJSONTyped)(json, ignoreDiscriminator)), { 'fileType': !(0, runtime_1.exists)(json, 'file_type') ? undefined : (0, ImageFileType_1.ImageFileTypeFromJSON)(json['file_type']), 'aspectRatio': !(0, runtime_1.exists)(json, 'aspect_ratio') ? undefined : (0, AspectRatio_1.AspectRatioFromJSON)(json['aspect_ratio']), 'width': !(0, runtime_1.exists)(json, 'width') ? undefined : json['width'], 'height': !(0, runtime_1.exists)(json, 'height') ? undefined : json['height'] });
}
exports.ImageFromJSONTyped = ImageFromJSONTyped;
function ImageToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return __assign(__assign({}, (0, Asset_1.AssetToJSON)(value)), { 'file_type': (0, ImageFileType_1.ImageFileTypeToJSON)(value.fileType), 'aspect_ratio': (0, AspectRatio_1.AspectRatioToJSON)(value.aspectRatio), 'width': value.width, 'height': value.height });
}
exports.ImageToJSON = ImageToJSON;
